import React from 'react';
import '../styles/privacyPolicy.css';
import html2pdf from 'html2pdf.js';

function PrivacyPolicy() {
  const downloadPDF = () => {
    const element = document.getElementById('privacy-policy-page');
    const clonedElement = element.cloneNode(true);
    
    // Remove the download button from the cloned element
    const downloadButtonContainer = clonedElement.querySelector('.download-button-container');
    if (downloadButtonContainer) {
      downloadButtonContainer.remove();
    }
    
    const opt = {
      margin: 10,
      filename: 'Privacy-Policy-Wedding-Stories.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, logging: false },
      jsPDF: { orientation: 'portrait', unit: 'mm', format: 'a4' },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };
    html2pdf().set(opt).from(clonedElement).save();
  };

  return (
    <div id="privacy-policy-page" className="privacy-policy-block">
      <div className="download-button-container">
        <button className="download-btn" onClick={downloadPDF}>
          ⬇ Download as PDF
        </button>
      </div>
      <p className="section-eyebrow">Legal</p>
      <h1 className="section-title">Privacy Policy</h1>
      <div className="section-line" aria-hidden="true" />

      <div className="privacy-content">
        <h2>Privacy Policy for WEDDING STORIES</h2>
        <p><strong>Effective Date: April 2026</strong></p>

        <p>At WEDDING STORIES, capturing your most cherished moments is our passion. We understand that wedding photographs and videos are highly personal, and we are deeply committed to protecting your privacy.</p>

        <p>This Privacy Policy outlines how we collect, use, store, and protect your personal data in compliance with India's Digital Personal Data Protection (DPDP) Act. By booking our services or using our website, you agree to the practices described below.</p>

        <h3>1. The Information We Collect</h3>
        <p>To provide you with a seamless photography and videography experience, we collect the following types of information:</p>
        <ul>
          <li><strong>Contact & Identification Data:</strong> Names, email addresses, phone numbers, and physical addresses (for delivering physical albums or products).</li>
          <li><strong>Event Data:</strong> Wedding dates, venue locations, event itineraries, and details about family members or VIP guests required to plan our coverage.</li>
          <li><strong>Digital Media (Personal Data):</strong> All photographs, video footage, and audio recordings captured by our team during your events.</li>
          <li><strong>Financial Information:</strong> Billing details needed to process invoices and payments securely.</li>
        </ul>

        <h3>2. How We Use Your Data (Purpose Limitation)</h3>
        <p>Under the DPDP Act, we only process your data for the specific purposes you have consented to:</p>
        <ul>
          <li><strong>Delivering Our Services:</strong> To plan, capture, edit, and deliver your wedding galleries and cinematic films.</li>
          <li><strong>Communication:</strong> To send quotes, contracts, invoices, digital gallery links, and important updates regarding your event.</li>
          <li><strong>Fulfillment:</strong> To design, print, and ship physical albums or framed prints.</li>
        </ul>

        <h3>3. Portfolio and Social Media Usage (Explicit Consent)</h3>
        <p>We love showing off our beautiful couples! However, your privacy comes first.</p>
        <ul>
          <li>We will never use your digital media (photos or videos) on our website, Instagram, Facebook, or promotional materials without your explicit, affirmative consent.</li>
          <li>Consent for marketing and portfolio use will be requested separately during the contract signing process. You are completely free to decline this without it affecting the quality of the services we provide to you.</li>
        </ul>

        <h3>4. Data Sharing and Third-Party Partners</h3>
        <p>We do not sell or rent your personal data. We only share necessary information with trusted third-party partners (Data Processors) who help us deliver your final products:</p>
        <ul>
          <li><strong>Printing Labs:</strong> Professional album binders who require your images and shipping address.</li>
          <li><strong>Online Galleries:</strong> Secure platforms used to host and deliver your digital photos and videos.</li>
          <li><strong>Payment Gateways:</strong> Secure processors used to handle financial transactions. We ensure that our partners also maintain strict security standards to protect your data.</li>
        </ul>

        <h3>5. Data Storage and Security</h3>
        <p>We take "reasonable security safeguards" to protect your digital memories from unauthorized access, loss, or data breaches:</p>
        <ul>
          <li>RAW files and edited footage are securely backed up on physical hard drives and protected cloud storage.</li>
          <li>Online delivery links are strictly password-protected or PIN-secured, accessible only by you (and those you choose to share the link with).</li>
        </ul>

        <h3>6. Your Rights Under the DPDP Act</h3>
        <p>As a client (Data Principal), you have the following rights regarding your personal data:</p>
        <ul>
          <li><strong>Right to Access:</strong> You may request details about the personal data we hold about you.</li>
          <li><strong>Right to Correction & Erasure (The Right to be Forgotten):</strong> You can ask us to update incorrect contact details. You may also withdraw your consent and request the deletion of your digital galleries or the removal of your images from our social media at any time. (Note: We may retain basic billing records as legally required for tax and accounting purposes.</li>
          <li><strong>Right to Grievance Redressal:</strong> If you have any concerns about how your data is being handled, you have the right to contact us for a prompt resolution.</li>
        </ul>

        <h3>7. Changes to This Policy</h3>
        <p>We may update this Privacy Policy to reflect changes in our business practices or legal requirements. Updated versions will be posted on this page with a revised "Effective Date."</p>

        <h3>8. Contact Us</h3>
        <p>For any questions regarding your privacy, to update your data, or to request the removal of your images, please reach out to us at:</p>
        <p><strong>WEDDING STORIES</strong><br />
        Location: Ranaghat, West Bengal, India<br />
        Email: weddingstoriesgroup@gmail.com<br />
        Phone: +917001385764</p>

        <h2>Explicit Consent Clause</h2>
        <h3>Model Release & Portfolio Usage Consent</h3>
        <p>At WEDDING STORIES, we take great pride in the beautiful moments we capture, and our portfolio is how we showcase our art to future clients. However, we deeply respect your privacy and your rights under India's Digital Personal Data Protection (DPDP) Act.</p>

        <p>Please review the options below and indicate your preference regarding how we may use the digital media (photographs, video, and audio) captured during your event. Your choice here does not affect the quality of the services we provide to you.</p>

        <p>Please select ONE of the following options by initialing on the line:</p>

        <h4>[ ] OPTION 1: Full Consent (Standard)</h4>
        <p>I/We hereby grant WEDDING STORIES the absolute and irrevocable right and permission to use, publish, and broadcast the photographs and video footage captured during our event(s).</p>
        <p>I/We understand these materials may be used for marketing, portfolio displays, advertising, social media (e.g., Instagram, Facebook), website galleries, and professional competitions.</p>
        <p>I/We understand that no personal contact details or exact locations will be published alongside the media without separate permission.</p>
        <p>I/We understand that under the DPDP Act, we reserve the right to withdraw this consent at any time in the future by contacting WEDDING STORIES in writing.</p>

        <h4>[ ] OPTION 2: Partial Consent (Anonymous / No Faces)</h4>
        <p>I/We consent to WEDDING STORIES using photographs and video footage from our event for portfolio and marketing purposes, WITH THE EXCEPTION OF identifiable faces.</p>
        <p>WEDDING STORIES may use detail shots (e.g., rings, decor, venue, outfits without faces) and anonymous silhouettes.</p>
        <p>I/We understand we can withdraw this consent at any time in writing.</p>

        <h4>[ ] OPTION 3: Strict Privacy (No Marketing Use)</h4>
        <p>I/We do not consent to the public use of our event photographs or videos.</p>
        <p>WEDDING STORIES agrees to keep all digital media strictly private and will not use any images or footage for social media, advertising, website portfolios, or public marketing. The media will only be processed for the purpose of delivering the final product to us.</p>

        <h3>Client Signatures:</h3>
        <p>Client 1 Name: _______________________ Signature: _______________________ Date: _________</p>
        <p>Client 2 Name: _______________________ Signature: _______________________ Date: _________</p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;